import { extendsDirectlyFromObject } from "@angular/core/src/render3/jit/directive";

export class ListUserAddress {
    address_name : string
    recid	 : string
    zipcode	: string 
  }
  
  export class Delivery {
    constructor(values: Object = {}){
      (<any>Object).assign(this, values);       
    }

    tipo : number
    id_tipo : string
    name : string
    zipcode : string
    transdate : string
    fromtime : string
    totime : string
    observacions : string
    timeDeliveryRemaining : string
    tipoRecogida: string

  }
  
  export class ScheduleDeliveries{
    
    deliveries : ScheduleDelivery[]
    
    constructor(values: ScheduleDelivery[]){
      this.deliveries = values;
    }

    contains (sDate : string ) : boolean {

      if (this.deliveries.find(schedule => schedule.transdate == sDate )){
        return true;
      }
      return false;

    }

    //20250602 axa inici
    //hours (sDate : String){

    //  return this.deliveries.filter( schedule => {
    //    return schedule.transdate == sDate;
    //  });

    //}
    

    hours(sDate?: String) {

      if (sDate) {
        return this.deliveries.filter(schedule => {
          return schedule.transdate == sDate;
        });
      }
      return this.deliveries;
    }
    //20250602 axa final

  }

  export class ScheduleDelivery {
    id_tipo	: string
    transdate	: string
    fromtime: string
    totime : string
  }

  export class DeliveryReservation {
    tipo : number
    id_tipo : string  
    fromtime : string
    totime : string
    transdate : string
    salesbasketid : number
    observacions : string
    tiporecogida : number
}

export class PreparationCenter {
  center_id: number
  street: string
  nameCa: string
  nameEs: string

  constructor(values: Object = {}) {
    (<any>Object).assign(this, values);
  }

  
}


export class ZipCode {
  center_id: number
  zipCodeid: string
  nameCa: string
  nameEs: string

  constructor(values: Object = {}) {
    (<any>Object).assign(this, values);
  }


}
//20250602 axa inici
export class DeliveryReservationAxA extends DeliveryReservation {
  isAxA: boolean
}
//20250602 axa final
